import React from 'react';
import cx from 'classnames';
import { Reveal } from 'react-reveal';

import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

interface Props {
  className?: string;
  reveal?: boolean;
  subtitle?: string | React.ReactNode;
  supertitle: string;
  supertitleIcon: any;
  title: string | React.ReactNode;
}

const SectionHeader: (React.FC<Props> & { Left?: any, Right?: any }) = (props) => {
  const left = React.Children.toArray(props.children).find((child) => (
    (child as React.ReactElement<any>).type === SectionHeader.Left)
  );
  const right = React.Children.toArray(props.children).find((child) => (
    (child as React.ReactElement<any>).type === SectionHeader.Right)
  );

  const FadeInReveal = ({ children }) => {
    if (props.reveal) {
      return (
        <Reveal duration={1000} effect={marketingStyles.fadeIn}>
          {children}
        </Reveal>
      )
    } else {
      return children;
    }
  };

  const FadeInAndSlideUpReveal = ({ children }) => {
    if (props.reveal) {
      return (
        <Reveal duration={1000} effect={marketingStyles.fadeInAndSlideUp}>
          {children}
        </Reveal>
      )
    } else {
      return children;
    }
  };

  return (
    <div className={cx(props.className, 'align-items-center d-flex flex-1 gap-m justify-content-between')}>
      {left || <div className="flex-1 hidden-xs hidden-sm" />}

      <div style={{ flex: '2 1 0' }}>
        <div className="align-items-center d-flex flex-column gap-m">
          <FadeInReveal>
            <div className="align-items-center d-flex gap-s text-secondary">
              <div style={{ marginTop: -2 }}>
                <img alt="" src={props.supertitleIcon} />
              </div>
              <div className="text-inter text-medium" style={{ fontSize: 13 }}>{props.supertitle}</div>
            </div>
          </FadeInReveal>

          <FadeInAndSlideUpReveal>
            <h2 className={cx(styles.header, 'text-center u-margin-A-n')}><strong>{props.title}</strong></h2>

            {
              props.subtitle && (
                <div className="text-center text-inter" style={{ color: '#5C5C5C', fontSize: 15 }}>
                  {props.subtitle}
                </div>
              )
            }
          </FadeInAndSlideUpReveal>
        </div>
      </div>

      {right || <div className="flex-1 hidden-xs hidden-sm" />}
    </div>
  );
};

SectionHeader.Left = (props) => {
  return props.children;
};

SectionHeader.Right = (props) => {
  return props.children;
};

export default SectionHeader;
